<template>
  <div
    class="h-auto w-full rounded border-2 border-dashed border-gray-200 bg-main-primary bg-opacity-[0.03] p-16"
    @drop.prevent="onDrop"
    @dragenter.prevent="
      removeContainerActivity = false;
      dropActive = true;
    "
    @dragleave.prevent="dropActive = false"
    @dragover.prevent="
      removeContainerActivity = false;
      dropActive = true;
    "
  >
    <div>
      <div class="flex flex-col items-center justify-center">
        <div>
          <div
            class="mx-auto mb-3 flex h-20 w-20 items-center justify-center rounded-full bg-white p-4"
          >
            <NuxtImg
              src="/gifs/document.gif"
              class="h-12 w-12"
              alt="Document Icon"
            />
          </div>
          <span
            v-if="!containerActive || alwaysActive"
            class="text-md font-medium text-slate-900"
          >Drag & drop file here to upload</span>
        </div>

        <span
          v-if="!containerActive || alwaysActive"
          class="my-2 text-gray-500"
        >or</span>

        <PrimaryButton
          v-if="!containerActive || alwaysActive"
          class="!mb-4 !py-2"
          @click="triggerInput"
        >
          Browse files
        </PrimaryButton>

        <input
          ref="fileInput"
          type="file"
          class="hidden"
          accept=".pdf, .png, .jpg, .bmp, .jpeg, .xls, .csv, .xlsx"
          multiple="multiple"
          @change="receiveFileFromInput"
        >
        <slot :active="containerActive" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DragDropInput',

  props: {
    uploadIconStyle: {
      type: String,
      default: 'text-[#198661] h-14 w-14',
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    accept: {
      type: String,
      default: null,
    },
    alwaysActive: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['file-dropped'],

  data() {
    return {
      events: ['dragenter', 'dragleave', 'dragover', 'drop'],
      dropActive: false,
      removeContainerActivity: false,
    }
  },

  computed: {
    containerActive() {
      return this.dropActive && !this.removeContainerActivity
    },
  },

  watch: {
    fileList: {
      handler(newFiles, oldFiles) {
        this.removeContainerActivity
          = oldFiles?.length - newFiles?.length === 1
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.events.forEach(eventName =>
      document.body.addEventListener(eventName, this.preventDefaults),
    )
  },

  beforeUnmount() {
    this.events.forEach(eventName =>
      document.body.removeEventListener(eventName, this.preventDefaults),
    )
  },

  methods: {
    onDrop(event) {
      this.dropActive = true
      this.$emit('file-dropped', [...event.dataTransfer.files])
    },
    preventDefaults(event) {
      event.preventDefault()
    },
    triggerInput() {
      this.dropActive = false
      this.removeContainerActivity = false
      this.$refs.fileInput.click()
    },
    receiveFileFromInput(event) {
      const files = [...event.target.files]
      if (files.length) {
        this.$emit('file-dropped', files)
        this.dropActive = true
        event.target.files = null
      }
    },
  },
}
</script>
